var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDefaultCover(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 150 150",
    style: {
      enableBackground: "new 0 0 150 150"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M119,17.8H45.2c-8,0-14.4,6.5-14.4,14.4v84.5c0,0.7,0.1,1.4,0.2,2.1c0.3,6.4,5.5,11.5,12,11.5h75v0h1V17.8z M116.9,19.9 v86.4h-74V20.1c0.7-0.1,1.5-0.2,2.2-0.2H116.9z M44.3,128.2c-5.7,0-10.4-4.2-11.3-9.6c0-0.1,0-0.2,0-0.3c0-5.5,4.5-10,9.9-10h74 v19.9H44.3z M40.9,20.6v85.8c-3.4,0.6-6.3,2.6-8.1,5.4V32.2C32.8,26.9,36.2,22.4,40.9,20.6z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53.9,
    y: 88.7,
    width: 49.2,
    height: 2.1
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "77.1,41 77.1,81.5 79.1,81.5 79.1,41 95.5,57.4 97,55.9 78.1,37.1 59.3,55.8 60.8,57.3  "
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultCover);
export default __webpack_public_path__ + "static/media/DefaultCover.f8dde53fc0460e8b3b6d69d1a8c348e8.svg";
export { ForwardRef as ReactComponent };